import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import { insightsQueryExpressionMonarchLanguage } from './monarch-language';
import { insightsQueryExpressionThemes } from './theme';

let registered = false;

export const insightsQueryExpressionLanguage = {
  id: 'insightsqueryexpression',
  monarchLanguage: insightsQueryExpressionMonarchLanguage,
  themes: insightsQueryExpressionThemes,

  register() {
    if (registered)
      return;

    registered = true;

    monaco.languages.register({ id: this.id });

    monaco.languages.setMonarchTokensProvider(this.id, insightsQueryExpressionMonarchLanguage);

    for (let themeId of Object.keys(insightsQueryExpressionThemes)) {
      monaco.editor.defineTheme(themeId, insightsQueryExpressionThemes[themeId]);
    }

    this.registerCompletionItemProvider(sharedCompletionItemProvider);
    this.registerHoverProvider(sharedHoverProvider);
  },

  registerCompletionItemProvider(provider: monaco.languages.CompletionItemProvider) {
    return monaco.languages.registerCompletionItemProvider(this.id, provider);
  },

  registerHoverProvider(provider: monaco.languages.HoverProvider) {
    return monaco.languages.registerHoverProvider(this.id, provider);
  },

  assignComponentToModel(model: monaco.editor.ITextModel, component: any) {
    (model as any)[modelMonacoEditorComponentRefKey] = component;
  }
};

/** MonacoEditorComponent referenced is stored as a property under this key. */
const modelMonacoEditorComponentRefKey = '__monaco_editor_component_ref';

const sharedCompletionItemProvider: monaco.languages.CompletionItemProvider = {
  triggerCharacters: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.([".split(""),

  provideCompletionItems(
    model: monaco.editor.ITextModel,
    position: monaco.Position,
    context: monaco.languages.CompletionContext,
    token: monaco.CancellationToken): monaco.languages.ProviderResult<monaco.languages.CompletionList> {
    let monacoEditorComponent = (model as any)[modelMonacoEditorComponentRefKey];
    let completionItemProvider = monacoEditorComponent?.completionItemProvider;
    if (!completionItemProvider)
      return null;
    
    return completionItemProvider.provideCompletionItems(model, position, context, token);
  },

  resolveCompletionItem(
    item: monaco.languages.CompletionItem,
    token: monaco.CancellationToken): monaco.languages.ProviderResult<monaco.languages.CompletionItem> {
    let monacoEditorComponent = (item as any)[modelMonacoEditorComponentRefKey];
    let completionItemProvider = monacoEditorComponent?.completionItemProvider;

    if (!completionItemProvider || !('resolveCompletionItem' in completionItemProvider))
      return item;

    return completionItemProvider.resolveCompletionItem(item, token);
  }
};

const sharedHoverProvider: monaco.languages.HoverProvider = {
  provideHover(
    model: monaco.editor.ITextModel,
    position: monaco.Position,
    token: monaco.CancellationToken): monaco.languages.ProviderResult<monaco.languages.Hover> {
    let monacoEditorComponent = (model as any)[modelMonacoEditorComponentRefKey];
    let hoverProvider = monacoEditorComponent?.hoverProvider;

    if (!hoverProvider)
      return null;

    return hoverProvider.provideHover(model, position, token);
  }
};
